













import { Vue, Component } from "vue-property-decorator";

@Component
export default class LocaleChanger extends Vue {
    public langs = ["de", "en"];
}
